import { ReactNode } from 'react';
import cn from 'classnames';

import styles from './Status.module.scss';

import errorImg from '../../assets/error.png';
import validImg from '../../assets/valid.png';
import warningImg from '../../assets/warning.png';

export enum StatusType {
    Info = 'INFO',
    Error = 'ERROR',
    Warning = 'WARNING',
}
export type StatusTypeUnion = `${StatusType}`;

export type StatusProps = {
    type: StatusTypeUnion;
    header: string;
    body?: ReactNode;
    className?: string;
};

const iconsByType = {
    [StatusType.Info]: { src: validImg, alt: 'Information' },
    [StatusType.Error]: { src: errorImg, alt: 'Error' },
    [StatusType.Warning]: { src: warningImg, alt: 'Warning' },
};

export function Status(props: StatusProps) {
    const { type, header, body, className } = props;
    const icon = iconsByType[type];

    return (
        <div className={cn(styles.wrapper, className)}>
            <img className={styles.image} {...icon} />
            <header className={styles.header}>{header}</header>
            {body && <div className={styles.body}>{body}</div>}
        </div>
    );
}
